import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { errors, Log, SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import { ILandingInitData } from "../models";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApi = () => {
  const { t } = useTranslation();
  const { apiGet } = useLandingApiMethods();

  const getLandingInitData = useEvent(
    async ({
      companyId,
    }: {
      companyId: number;
    }): Promise<SimpleResult<ILandingInitData> | undefined> => {
      if (!companyId) {
        Log.warnAndToast(t(errors.common.invalidId));
        return undefined;
      }

      const response = await apiGet<SimpleResult<ILandingInitData>>(
        landingRoutesApiConst.initData(companyId),
      );

      return response?.data;
    },
  );

  return { getLandingInitData };
};
